module.exports = __webpack_public_path__ + "img/jkopay.e20fe2e1.svg";